<template>
    <button type="button" :class="customClasses" :disabled="disabled" :data-dd="$.uid">
        <slot name="default"></slot>
    </button>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from '@/helpers/Decorators';

@Options({
    name: 'ideo-dropdown-item-button'
})
export default class IdeoDropdownItemButton extends Vue
{
    @Prop({ default: false })
    public active: boolean;

    @Prop({ default: 'active' })
    public activeClass: string;

    @Prop({ default: false })
    public disabled: boolean;

    @Prop({
        default: null,
        validator: (value: string) => ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'].includes(value)
    })
    public variant: string;

    public get customClasses(): Record<string, boolean>
    {
        return {
            'dropdown-item': true,
            [this.activeClass]: this.active,
            [`text-${this.variant}`]: this.variant != null
        };
    }
}
</script>
